import './style.css';

import { Checkbox, FormControlLabel } from '@material-ui/core';
import refs from 'bz-utilities/modules/legacy/refs';
import _ from 'lodash';
import React from 'react';
import Text from '../text';

@refs('input')
class List extends React.Component {
  static defaultProps = { value: [] };

  state = {
    text: '',
    currentValue: '',
    hasValue: (this.props.value || []).length > 0 && _.isObject(this.props.value[0])
  };

  render() {
    let { value } = this.props;
    let { hasValue } = this.state;
    if (!_.isArray(value)) {
      value = [];
    }

    const items = value.map((x, i) => {
      return (
        <div key={i} className="list-row item-row">
          <div className="list-content">{hasValue ? `${x.text} [${x.value}]` : x}</div>
          <div className="list-icon list-remove">
            <i className="fa fa-times-circle fa-lg" onClick={this.onRemove.bind(this, i)} />
          </div>
        </div>
      );
    });

    return (
      <div className="bz-list">
        <FormControlLabel
          label={'Enable value mode'}
          control={<Checkbox checked={hasValue} onChange={this.onValueModeChange} />}
        />
        <div className="list-row">
          <div className="list-content">
            <Text
              ref={this._refs.input}
              placeholder={'Item'}
              value={this.state.text}
              onChange={this.onChange}
              multiLine={false}
            />
            {hasValue && (
              <Text
                ref={this._refs.input}
                placeholder={'Value'}
                value={this.state.currentValue}
                onChange={(currentValue) => this.setState({ currentValue })}
                multiLine={false}
              />
            )}
          </div>
          <div className="list-icon list-add">
            <i className="fa fa-plus-circle fa-lg" onClick={this.onAdd} />
          </div>
        </div>
        <div>{items}</div>
      </div>
    );
  }

  onAdd = () => {
    const { value } = this.props;
    let { text, currentValue } = this.state;
    if (this.state.hasValue) {
      (value || []).push({ text, value: currentValue });
    } else {
      (value || []).push(this.state.text);
    }
    if (this.props.onChange != null) {
      this.props.onChange.call(this, value);
    }
    return this.setState({ text: '', currentValue: '' });
  };

  onRemove = (idx) => {
    const { value } = this.props;
    value.splice(idx, 1);
    return this.props.onChange != null ? this.props.onChange.call(this, value) : undefined;
  };

  onKeyDown = (e) => {};

  onChange = (text) => {
    return this.setState({ text });
  };

  onValueModeChange = () => {
    let { hasValue } = this.state;
    let { value } = this.props;
    hasValue = !hasValue;

    if (hasValue) {
      value = value.map((x) => ({ value: x, text: x }));
    } else {
      value = value.map(({ text }) => text);
    }

    if (this.props.onChange != null) {
      this.props.onChange.call(this, value);
    }
    return this.setState({ text: '', hasValue });
  };
}

export default List;
